import React, { Fragment, ReactNode } from 'react'
import { GridElementOTInbound } from './GridElementOTInbound'
import { Pagination } from '../../UI/Pagination/Pagination'
import { Select } from '@mui/material'
import { SelectChangeEvent } from '@mui/material/Select'

import { NoRows } from '../../ElementList/NoRows'
import { SortField } from '../../../interfaces/DataGrid/DataGridSettings'
import { DataGrid } from '../../DataGrid/DataGrid'
import { dataGridSettings } from '../otInboundConfig'
import { OtInbound } from '../../../interfaces/Planner/Planner'
import { Loading } from '../../UI'

interface OTInboundElementList {
  otInbound: OtInbound[]
  page: number
  totalPages: number
  pageSize: number
  handlePagination: (updatePage: number) => void
  handlePageSize: (
    event: SelectChangeEvent<number>,
    child: ReactNode
  ) => void
  sorters: SortField[]
  handleOnSortChanged: (sorters: SortField[]) => void
  childComponent?: JSX.Element | JSX.Element[]
  isLoadingConfirm: boolean
  handleGetOt: () => void
}

export const OTInboundElementList: React.FC<OTInboundElementList> = ({
  otInbound,
  page,
  totalPages,
  pageSize,
  handlePagination,
  handlePageSize,
  handleOnSortChanged,
  sorters,
  childComponent,
  isLoadingConfirm,
  handleGetOt
}) => {
  return (
    <Fragment>
      <DataGrid
        items={otInbound}
        settings={dataGridSettings}
        sorters={sorters}
        onSortChanged={handleOnSortChanged}
        childComponent={childComponent}
      >
        {(order) => (
          <GridElementOTInbound
            handleGetOt={handleGetOt}
            page={page}
            pageSize={pageSize}
            element={order}
            dataGridSettings={dataGridSettings}
            isLoadingConfirm={isLoadingConfirm}
          />
        )}
      </DataGrid>

      {!isLoadingConfirm &&
      otInbound.length > 0 ? undefined : !isLoadingConfirm &&
        otInbound.length === 0 ? (
        <NoRows />
      ) : (
        <Loading />
      )}

      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 10 }}>
        <Select
          native
          value={pageSize}
          onChange={handlePageSize}
          style={{ alignSelf: 'flex-end' }}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
        </Select>
      </div>
      <Pagination
        page={page}
        totalPages={totalPages}
        handlePagination={handlePagination}
      />
    </Fragment>
  )
}
